import useWeb3 from "../hooks/useWeb3";

export default function WalletButton({
	children,
	className = "",
	active = "",
	inactive = "",
}: {
	children: React.ReactNode;
	className?: string;
	active?: string;
	inactive?: string;
}) {
	const { connect, disconnect, account } = useWeb3();

	return account ? (
		<button className={`${className} ${active}`.trim()} onClick={disconnect}>
			{account}
		</button>
	) : (
		<button className={`${className} ${inactive}`.trim()} onClick={connect}>
			{children}
		</button>
	);
}
